import React from 'react'
import { observer } from 'mobx-react'
import { CardContent } from 'components/Card'
import Button from 'components/Button'
import JobProgressionViewModel from '../JobProgressionViewModel'
import { JobProgressionFlow } from 'jobs/progression/JobProgression'
import { match } from 'utils/pattern-match-util'
import styles from './DraftApproved.sass'

interface Props {
  vm: JobProgressionViewModel
  canCompleteJob?: boolean
}
export default observer(function DraftApprovedProgressionActions({
  vm,
  canCompleteJob,
}: Props) {
  return match(vm.currentProgressionFlow, {
    [JobProgressionFlow.OUTSOURCING]: () => (
      <OutsourcingActions vm={vm} canCompleteJob={canCompleteJob} />
    ),
    [JobProgressionFlow.RETAIL]: () => <RetailActions vm={vm} />,
    [JobProgressionFlow.NONE]: () => null,
  })
})

const RetailActions = ({ vm }: Props) => {
  return (
    <CardContent>
      <Button
        type="primary"
        size="wide-slim"
        onClick={() => vm.answerAuthorizationSigned()}
        dataTest="job-progression-set-authorization-received-button"
      >
        Authorization was received
      </Button>
    </CardContent>
  )
}

const OutsourcingActions = ({ vm, canCompleteJob }: Props) => {
  return (
    <>
      <CardContent>
        <Button
          type="primary"
          size="wide-slim"
          onClick={() => vm.closeJob()}
          dataTest="job-progression-complete-job-button"
          disabled={!canCompleteJob}
        >
          Complete Job
        </Button>
        {!canCompleteJob && (
          <div className={styles.pendingCall}>Pending call completion</div>
        )}
      </CardContent>
    </>
  )
}
